import bodyClass from "discourse/helpers/body-class";
import ModMarketRouteStatus from "discourse/plugins/discourse-mod-market/discourse/components/mod-market-route-status";

export default <template>
  {{bodyClass "mod-market-page"}}
  <ModMarketRouteStatus @loading={{true}} />
</template>;
